import { Colors } from 'advance-components';
const colorTheme = {
  default: {
    textColor: Colors.advanceBlue50,
    iconColor: Colors.white
  },
  light: {
    textColor: Colors.gray600,
    iconColor: Colors.gray200
  }
};
export default colorTheme;
//# sourceMappingURL=color-theme.js.map